import { kebabCase } from "lodash";
import { t } from "@/i18n-js/instance";
import { BoxModelInput } from "@/react/components/shared/BuilderUI/Editor/fields/BoxModelField";
import { Accordion } from "@circle-react-uikit/Accordion";
import type { ButtonType, ButtonVariant } from "./index";

interface SpacingProps {
  buttonType: ButtonType;
  buttonVariant: ButtonVariant;
}

export const Spacing = ({ buttonType, buttonVariant }: SpacingProps) => {
  if (buttonVariant === "hover") {
    return null;
  }

  return (
    <div className="px-6 pt-5">
      <Accordion defaultOpen>
        <Accordion.Item title={t("builder_ui.prop_type.styles.padding")}>
          <div className="pt-1">
            <BoxModelInput
              type="padding"
              name={`theme.${buttonType}.theme-website-${kebabCase(buttonType)}`}
              variableType="hyphen"
              label={t("builder_ui.prop_type.styles.padding")}
            />
          </div>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};
